import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import ListingContent from '@spotahome/marketplace-common/src/components/ListingContent';

import { ListingSection } from './ListingSection';
import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';

import './ListingHighlights.scss';

const ListingHighlight = ({ titleKey, content }) =>
  content && (
    <div className="listing-highlights__item">
      <ListingTitle role="secondary">{trans(titleKey)}</ListingTitle>
      <ListingContent content={content} />
    </div>
  );
ListingHighlight.propTypes = {
  content: PropTypes.string.isRequired,
  titleKey: PropTypes.string.isRequired
};

const ListingHighlights = ({
  thingsToKeepInMind = null,
  whatWeLiked = null
}) => (
  <ListingSection>
    <div className="listing-highlights">
      <ListingHighlight
        titleKey="property_show.title.like_most"
        content={whatWeLiked}
      />
      <ListingHighlight
        titleKey="property_show.title.keep_mind"
        content={thingsToKeepInMind}
      />
    </div>
  </ListingSection>
);

ListingHighlights.propTypes = {
  thingsToKeepInMind: PropTypes.string,
  whatWeLiked: PropTypes.string
};

export default ListingHighlights;
